import React, {Component} from "react";
import {connect} from "react-redux";
import {Icon, Modal, Header} from "semantic-ui-react";
import {HelpPages} from "../../constants";
import {getHelpList} from "../../redux/modules/help";
import Loading from "../Loading";
import ErrorModal from "../ErrorModal";
import ViewFileModal from "./ViewFileModal";

class HelpPageModal extends Component {

    state = {openFileModal: false, files: null}

    componentWillMount = () => {
        this.fetchData();
    }

    fetchData = () => {
        const {dispatch, pageId} = this.props;
        dispatch(getHelpList(pageId))
            .then(res => {
                if (res && res.length) {
                    res.forEach(item => {
                        item.page = (
                            (item.parentPageId && HelpPages[item.parentPageId] && HelpPages[item.pageId]) ?
                                `${HelpPages[item.parentPageId].name} > ${HelpPages[item.pageId].name}` :
                                HelpPages[item.pageId] ? HelpPages[item.pageId].name : ""
                        );
                    });
                }
                this.setState({data: res});
            })
            .catch(err => {
                console.log('Found error on get help list', err);
            });
    }

    openFileModal = (type, files) => {
        this.setState({openFileModal: type, files: files});
    }

    closeFilesModal = () => {
        this.setState({openFileModal: false, files: null});
    }

    render() {
        const {hideHelpPageModal, pageId, isLoad, loadErr} = this.props;
        const {data, openFileModal, files} = this.state;
        return (
            <Modal
                open={true}
                onClose={hideHelpPageModal}
                centered={false}
                size='large'
                closeIcon
            >
                { isLoad && <Loading /> }
                { (loadErr) && <ErrorModal hideDetailsModal={this.hideErrorModal} errorMessage={loadErr}/> }
              <Header content={`Help for ${(HelpPages[pageId]) ? (HelpPages[pageId].name && HelpPages[pageId].name.replace('UDR - ','') ): ""}`}/>
              <Modal.Content>
                <div className="row">
                  <div className='col-12'>
                    <ul className="helpList mb-0">
                        { (data && data.length) ?
                            data.map((item, key) => {
                                return (

                                    <li key={key}>
                                      <strong>{item.heading}</strong>
                                      <div>
                                          { item.description && <p className="mb-2">{item.description}</p> }
                                          { (item.fileLinks && item.fileLinks.toLowerCase().indexOf('.mp4') > 0) &&
                                          <span onClick={() => this.openFileModal('Video', item.fileLinks)}
                                                className="cursorPointer"><Icon className="primaryColor mr-2"
                                                name="play circle"/><span className="linkText">Watch Video</span></span> }
                                          { (item.fileLinks && item.fileLinks.toLowerCase().indexOf('.pdf') > 0) &&
                                          <span onClick={() => this.openFileModal('PDF', item.fileLinks)}
                                                className="cursorPointer"><Icon className="primaryColor mr-2"
                                                 name="file pdf"/><span className="linkText">View PDF</span></span> }
                                      </div>
                                    </li>

                                )
                            })
                            :
                            <div>No record found.</div>
                        }
                    </ul>
                  </div>
                </div>
              </Modal.Content>
                {openFileModal && <ViewFileModal closeModal={this.closeFilesModal} files={files} type={openFileModal}/>}
            </Modal>
        );
    }
}
export default connect(
    state => ({
        helpList: state.get('help').get('helpList'),
        isLoad: state.get('help').get('isLoad'),
        loadErr: state.get('help').get('loadErr')
    }))(HelpPageModal);
